import { createFileRoute } from '@tanstack/react-router';
import { HistoryPage } from '@/page/HistoryPage';

export const Route = createFileRoute('/_app/history')({ component: HistoryPage });
